import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for migrated `/admin/*` URLs.
 *
 * Kept separate from `admin.ts` (the `RouteObject` tree) so `RouteUrls.ts` and pages can
 * import paths without creating a cycle through page `Component` imports.
 *
 * Nested routes compose from their parent's `.path` so the hierarchy stays visible and absolute
 * strings stay in sync (RR6 requires a child's path to start with its parent's).
 */
export const adminRoute = defineRoute("/admin");
export const adminProjectsRoute = defineRoute(`${adminRoute.path}/projects`);
export const adminUsersRoute = defineRoute(`${adminRoute.path}/users`);
export const adminItemsRoute = defineRoute(`${adminRoute.path}/items`);
export const adminCostCodesRoute = defineRoute(`${adminRoute.path}/costCodes`);
export const adminFeatureFlagsRoute = defineRoute(`${adminRoute.path}/feature-flags`);
export const adminUserGroupsRoute = defineRoute(`${adminRoute.path}/user-groups`);
export const adminLocationsRoute = defineRoute(`${adminRoute.path}/locations`);
export const adminFeatureTypesRoute = defineRoute(`${adminRoute.path}/feature-types`);
export const adminInfrastructureRoute = defineRoute(`${adminRoute.path}/infrastructure`);
export const adminFinishScheduleRoute = defineRoute(`${adminRoute.path}/finish-schedule`);
export const adminFinishScheduleCostCodeRoute = defineRoute(`${adminRoute.path}/finish-schedule/:costCodeId`);
/** Bookmark-only admin page (not in Admin side nav). */
export const adminTradeCategoriesRoute = defineRoute(`${adminRoute.path}/tradeCategories`);
